import './shoppingNav.css';

var styles = {"headerWrapper":"headerWrapper__26kl2","content":"content__2iku-","primeDay":"primeDay__W5VJN","headerCategoryWrapper":"headerCategoryWrapper__2aVqY","headerContent":"headerContent__1VHQC","storybookWrapper":"storybookWrapper__1oz0p"};

export { styles as default };
